import EggConfig, {EggEntity} from "../config/EggConfig";
import ItemEggDrawing from "./ItemEggDrawing";

const {ccclass, property} = cc._decorator;
/**
 * 鸡蛋Page
 */
@ccclass
export default class EggPage extends cc.Component {

    @property(cc.Prefab)
    itemEggDrawing : cc.Prefab = null;
    @property(cc.Node)
    contentNode : cc.Node = null;

    onLoad () {}

    start () {
        this.loadData();
    }

    /**
     * 加速数据
     */
    loadData(){
        let eggDataList : EggEntity[] = EggConfig();
        for ( let eggItemData of eggDataList ) {
            let itemEggDrawingNode = cc.instantiate( this.itemEggDrawing );
            this.contentNode.addChild( itemEggDrawingNode );
            itemEggDrawingNode.getComponent( ItemEggDrawing ).bindData( eggItemData );
        }
    }

    // update (dt) {}
}
